import { SignInSignUpOption } from "shared/enums/SignInSignUpOptionEnum";
import { getValue, setValue } from "./StorageUtility";

interface RememberMe {
  signInOption: SignInSignUpOption;
  isRemembered: boolean;
  email: string;
  phone: string;
  phoneCode: string;
  phoneNumberWithCode: string;
}

const rememberMeKey = "rememberMeDataKey";

export const getRememberedSignInData = () => {
  const data = getValue(rememberMeKey);
  return (data ? JSON.parse(data) : {}) as RememberMe;
};

export const setRememberedSignInData = (rememberMeData: RememberMe) => {
  let data = { signInOption: rememberMeData.signInOption };
  if (rememberMeData.isRemembered) {
    data = {
      ...data,
      ...rememberMeData,
    };
  }
  setValue(rememberMeKey, JSON.stringify(data));
};
